<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="addsaveClick('formData')"
            >确 定
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              ref="formData"
              :model="formData"
              :rules="rules"
              label-width="140px"
              class="eidt-el-form"
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="剩余数量" prop="quantity">
              <el-input type="number" v-model="formData.quantity"></el-input>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                  v-model="formData.price"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker
                  v-model="formData.startDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="使用开始时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                  v-model="formData.endDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="使用结束时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="使用有效时间" prop="effectiveDate">
              <el-date-picker
                  v-model="formData.effectiveDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="有效时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px">实体票图片</label>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg2"
                :editImg="editImg2"
                :imgTitle="imgTitle2"
            ></UploadImg>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px">购票图片</label>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg1"
                :editImg="editImg1"
                :imgTitle="imgTitle1"
            ></UploadImg>
            <el-form-item label="表单图宽度">
              <el-input v-model="formData.person" type="number"></el-input>
            </el-form-item>
            <el-form-item label="表单图高度">
              <el-input v-model="formData.number" type="number"></el-input>
            </el-form-item>
            <el-form-item label="表单上边距">
              <el-input v-model="formData.top" type="number"></el-input>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px">电子票图片</label>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
            <el-form-item label="票图片宽度" prop="width">
              <el-input
                  v-model="formData.width"
                  type="number"
                  min="1"
              ></el-input>
            </el-form-item>
            <el-form-item label="票图片高度" prop="height">
              <el-input
                  v-model="formData.height"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码左边距" prop="qrcodeX">
              <el-input
                  v-model="formData.qrcodeX"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码上边距" prop="qrcodeY">
              <el-input
                  v-model="formData.qrcodeY"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码大小" prop="qrcodeSize">
              <el-input
                  v-model="formData.qrcodeSize"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="show()">预览</el-button>
            </el-form-item>
            <el-form-item label="是否启用小程序">
              <el-radio-group v-model="formData.enabled">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px">小程序图片</label>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg3"
                :editImg="editImg3"
                :imgTitle="imgTitle3"
            ></UploadImg>
            <el-form-item label="小程序点击率" prop="hit">
              <el-input v-model="formData.hit" type="number" min="0"></el-input>
            </el-form-item>
            <el-form-item label="微信分享标题" prop="title">
              <el-input v-model="formData.title" type="text"></el-input>
            </el-form-item>
            <el-form-item label="微信分享描述" prop="description">
              <el-input
                  v-model="formData.description"
                  :autosize="{ minRows: 4, maxRows: 1000 }"
                  type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px"
              >微信分享图片:只能jpg格式</label
              >
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg4"
                :editImg="editImg4"
                :imgTitle="imgTitle4"
            ></UploadImg>
          </el-form>
          <div class="img-box">
            <el-image :src="editImg"></el-image>
            <div id="qrcode" ref="qrcode" :style="style"></div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      //角色列表数据
      rules: {
        name: [
          {required: true, message: "类型名称不能为空", trigger: "blur"},
        ],
        quantity: [
          {required: true, message: "剩余数量不能为空", trigger: "blur"},
        ],
        price: [{required: true, message: "价格不能为空", trigger: "blur"}],
        // endDate: [
        //   {required: true, message: "结束日期不能为空", trigger: "blur"},
        // ],
        // startDate: [
        //   {required: true, message: "开始日期不能为空", trigger: "blur"},
        // ],
        qrcodeSize: [
          {required: true, message: "二维码大小不能为空", trigger: "blur"},
        ],
        qrcodeX: [
          {required: true, message: "二维码X坐标不能为空", trigger: "blur"},
        ],
        qrcodeY: [
          {required: true, message: "二维码Y坐标不能为空", trigger: "blur"},
        ],
        height: [
          {required: true, message: "页面高度不能为空", trigger: "blur"},
        ],
        width: [
          {required: true, message: "页面宽度不能为空", trigger: "blur"},
        ],
      },
      // defaultProps: {
      //   label: "name",
      // },
      dialogVisible: false,
      formData: {
        projectId: localStorage.getItem("project_Id"),
        name: "",
        quantity: 0,
        number: 0,
        price: 0,
        person: 0,
        width: 0,
        height: 0,
        banner: "",
        top: 0,
        url: "",
        qrcodeX: 0,
        qrcodeY: 0,
        rule: "",
        qrcodeSize: 0,
        hit: 0,
        startDate: "",
        wechatUrl: "",
        enabled: "",
        endDate: "",
        effectiveDate: "",
        title: "",
        description: "",
        img: "",
      },
      style: {position: "absolute", display: "none"},
      editImg: "",
      editImg1: "",
      editImg2: "",
      editImg3: "",
      formeditData: {},
      ticketType_Id: -1,
      imgTitle: "电子票图片",
      imgTitle1: "购票图片",
      imgTitle2: "实体票图片",
      imgTitle3: "小程序图片",
      imgTitle4: "微信分享图片",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      const item = this.editData;
      if (item) {
        this.formData = item;
        this.editImg = item.url;
        this.editImg1 = item.rule;
        this.editImg2 = item.banner;
        this.editImg3 = item.wechatUrl;
        this.editImg4 = item.img;
        this.ticketType_Id = item.ticketTypeId;
      }
      this.show();
    },
  },
  created() {
  },
  methods: {
    show() {
      document.getElementById("qrcode").innerHTML = "";
      let qrcode = new QRCode("qrcode", {
        text: "qrcode",
        width: (this.formData.qrcodeSize / this.formData.width) * 400,
        height: (this.formData.qrcodeSize / this.formData.width) * 400,
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H,
      });
      this.style = {
        left: (this.formData.qrcodeX / this.formData.width) * 400 + "px",
        top: (this.formData.qrcodeY / this.formData.width) * 400 + "px",
        width: (this.formData.qrcodeSize / this.formData.width) * 400 + "px",
        height: (this.formData.qrcodeSize / this.formData.width) * 400 + "px",
      };
    },
    nodebg(val) {
      bus.$emit("putrole", val.project_Role_Id);
    },
    addsaveClick(formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          if (this.ticketType_Id == -1) {
            this.$axios.post("/TicketType/", this.formData).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("添加成功！");
                this.$refs[formData].resetFields();
                this.goBack();
              } else {
                this.$message.error("添加失败！");
              }
            });
          } else {
            this.$axios
                .put(`/TicketType/${this.ticketType_Id}`, this.formData)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("修改成功！");
                    this.$refs[formData].resetFields();
                    this.ticketType_Id = -1;
                    this.goBack();
                  } else {
                    this.$message.error("添加失败！");
                  }
                });
          }
          this.dialogVisible = false;
        }
      });
    },
    closeVisible(formData) {
      this.$refs[formData].resetFields();
      this.dialogVisible = false;
    },
    getById(data) {
      bus.$emit("getTicketTypeId", data.ticketTypeId);
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.$refs["formData"].resetFields();
      this.editImg = "";
      this.editImg1 = "";
      this.editImg2 = "";
      this.editImg3 = "";
      this.editImg4 = "";
      this.ticketType_Id = -1;
    },
    getUploadImg(imgSrc) {
      this.editImg = imgSrc;
      this.formData.url = imgSrc;
    },
    getUploadImg1(imgSrc1) {
      this.editImg1 = imgSrc1;
      this.formData.rule = imgSrc1;
    },
    getUploadImg2(imgSrc2) {
      this.editImg2 = imgSrc2;
      this.formData.banner = imgSrc2;
    },
    getUploadImg3(imgSrc3) {
      this.imgSrc3 = imgSrc3;
      this.formData.wechatUrl = imgSrc3;
    },
    getUploadImg4(imgSrc4) {
      this.imgSrc4 = imgSrc4;
      this.formData.img = imgSrc4;
    },
  },
  components: {
    UploadImg,
  },
};
</script>
<style lang="scss" scope>
.img-box {
  float: right;
  width: 400px;
  position: absolute;
  top: 80px;
  right: 0px;
}

img {
  width: 100%;
}

#qrcode {
  position: absolute;
}
</style>